import { onlineManager } from '@tanstack/react-query';

export const getIsOnline = () => onlineManager.isOnline();
